<template>
  <div class="stars">
    <div class="star" v-for="i in 5" @click="updateVal(i)" :class="{'cursor-pointer': clickable}">
      <template v-if="i > value">
      <svg width="1.145vw" height="1.145vw" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.1557 17.3901L10.8615 17.1836L10.5721 17.3967L5.17798 21.3673L5.17611 21.3687C4.91605 21.562 4.64131 21.5258 4.43917 21.3633C4.23245 21.197 4.11418 20.904 4.2344 20.5703L4.23899 20.5576L4.24288 20.5446L6.21634 13.9726L6.31469 13.645L6.0451 13.4346L0.782564 9.32706L0.782649 9.32695L0.773211 9.31993C0.506204 9.12145 0.450052 8.84337 0.538228 8.57826C0.629409 8.30412 0.867127 8.07909 1.17363 8.02972L7.72131 7.89347L8.07143 7.88618L8.18425 7.55467L10.4193 0.987249C10.5456 0.641383 10.8162 0.5 11.0494 0.5C11.2744 0.5 11.4916 0.626934 11.5664 0.938299L11.5718 0.960742L11.5792 0.982592L13.8157 7.55466L13.9286 7.88618L14.2787 7.89347L20.8569 8.03035L20.8569 8.03046H20.8673C21.1268 8.03046 21.3619 8.21535 21.46 8.52162C21.5554 8.81932 21.4848 9.12816 21.2268 9.31993L21.2267 9.31982L21.2174 9.32706L15.9549 13.4346L15.6853 13.645L15.7837 13.9726L17.7527 20.5299C17.8335 20.8847 17.7031 21.16 17.5142 21.3098C17.3289 21.4568 17.0664 21.5026 16.7958 21.3487L11.1557 17.3901Z" stroke="#B4BDC6"/>
      </svg>
      </template>
      <template v-else>
      <svg width="1.145vw" height="1.145vw" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8685 17.7993L5.4744 21.77C4.55345 22.4546 3.36932 21.4962 3.76401 20.4008L5.73746 13.8288L0.474919 9.72121C-0.446026 9.03662 0.0802282 7.66738 1.13274 7.53046L7.71091 7.39358L9.94759 0.82151C10.3423 -0.273837 11.7894 -0.273837 12.0526 0.82151L14.2891 7.39358L20.8673 7.53046C21.9198 7.53046 22.446 9.03662 21.5251 9.72121L16.2625 13.8288L18.236 20.4008C18.4991 21.4962 17.4467 22.3177 16.5258 21.77L10.8685 17.7993Z" fill="#F28C16"/>
      </svg>
      </template>
    </div>
  </div>
</template>

<script>

    export default {
        props: {
            value: Number,
            clickable: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                currentValue: this.value
            };
        },
        components: {},
        mounted() {

        },
        methods: {
          updateVal(i){
              this.currentValue = i;
          }
        },
        watch: {
            currentValue(val) {
                this.$emit('input', val);
            }
        }
    }
</script>

<style lang="scss">

  .stars{
    width: 144px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 8px;
    position: relative;
    top: 3px;
    .star{
      &.cursor-pointer{
        &:hover{
          cursor: pointer;
        }
      }
    }
  }
</style>
